import { render, staticRenderFns } from "./docsManage.vue?vue&type=template&id=37c8f1e0&scoped=true&"
import script from "./docsManage.vue?vue&type=script&lang=js&"
export * from "./docsManage.vue?vue&type=script&lang=js&"
import style0 from "./docsManage.vue?vue&type=style&index=0&id=37c8f1e0&lang=less&scoped=true&"
import style1 from "./docsManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c8f1e0",
  null
  
)

export default component.exports